import { useState } from 'react';
import AtomicBlockItem from './AtomicBlockItem';
import BlockType from '../../../models/BlockType';
import BlockData from '../../../models/BlockData';
import BlockHeaderData from '../../../components/Blocks/Headers/BlockHeader/BlockHeaderData';
import BlockHeaderWithLogoData from '../../../components/Blocks/Headers/BlockHeaderWithLogo/BlockHeaderWithLogoData';
import BlockHeaderLogoMenuData from '../../../components/Blocks/Headers/BlockHeaderLogoMenu/BlockHeaderLogoMenuData';
import BlockTitleData from '../../../components/Blocks/BlockTitle/BlockTitleData';
import BlockImageData from '../../../components/Blocks/BlockImage/BlockImageData';
import BlockTextWithBackgroundData from '../../../components/Blocks/BlockTextWithBackground/BlockTextWithBackgroundData';
import BlockImageAndTextData from '../../../components/Blocks/BlockImageAndText/BlockImageAndTextData';
import BlockMenuListData from '../../../components/Blocks/BlockMenuList/BlockMenuListData';
import BlockMapData from '../../../components/Blocks/BlockMap/BlockMapData';
import BlockTextData from '../../../components/Blocks/BlockText/BlockTextData';
import BlockCardData, { BlockCardVariant } from '../../../models/Block/BlockCardData';
import BlockLinedTitleData from '../../../components/Blocks/BlockLinedTitle/BlockLinedTitleData';
import BlockiFrameData from '../../../components/Blocks/BlockiFrame/BlockiFrameData';
import BlockFooterData from '../../../components/Blocks/BlockFooter/BlockFooterData';
import BlockTableData, { BlockTableVariant } from '../../../components/Blocks/BlockTable/BlockTableData';
import BlockCardCenteredData, { BlockCardCenteredVariant } from '../../../models/Block/BlockCardCenteredData';
import BlockTextListData from '../../../components/Blocks/BlockTextList/BlockTextListData';
import BlockButtonListData from '../../../components/Blocks/BlockButtonList/BlockButtonListData';
import BlockCenteredImageData from '../../../components/Blocks/BlockCenteredImage/BlockCenteredImageData';
import { BlockAlign, BlockHeight, BlockJustify } from '../../../models/BlockSettings';
import BlockFullBleedImageData from '../../../components/Blocks/BlockFullBleedImage/BlockFullBleedImageData';
import BlockCarouselData from '../../../components/Blocks/BlockCarousel/BlockCarouselData';
import BlockTitleTextButtonData from '../../../components/Blocks/BlockTitleTextButton/BlockTitleTextButtonData';
import BlockImageListData from '../../../components/Blocks/BlockImageList/BlockImageListData';
import BlockButtonData from '../../../components/Blocks/BlockButton/BlockButtonData';
import BlockHtmlData from '../../../components/Blocks/BlockHtml/BlockHtmlData';
import BlockSNSData from '../../../components/Blocks/BlockSNS/BlockSNSData';
import config from '../../../config';
import ModalComponent from '../../../components/ModalComponent';
import { BlockAnimationBlockData } from '../../../components/Blocks/BlockAnimationBlocks/BlockAnimationBlockData';
import BlockContactData from '../../../components/Blocks/BlockContact/BlockContactData';
import BlockVideoData from '../../../components/Blocks/BlockVideo/BlockVideoData';
import { BlockAnimationWithImageDescriptionData } from '../../../components/Blocks/BlockAnimationWithImageDescription/BlockAnimationWithImageDescriptionData';
import BlockMenuListWithColumnsData from '../../../components/Blocks/BlockMenuListWithColumns/BlockMenuListWithColumnsData';
import BlockMenuListWithEqualSpaceData from '../../../components/Blocks/BlockMenuListWithEqualSpace/BlockMenuListWithEqualSpaceData';
import BlockHtmlSafeData from '../../../components/Blocks/BlockHtmlSafe/BlockHtmlSafeData';
import BlockiFrameSafeData from '../../../components/Blocks/BlockiFrameSafe/BlockiFrameSafeData';
import BlockMenuListFixedMax2Data from '../../../components/Blocks/BlockMenuListFixedMax2/BlockMenuListFixedMax2Data';
import BlockMenuListFixedMax3Data from '../../../components/Blocks/BlockMenuListFixedMax3/BlockMenuListFixedMax3Data';
import BlockMenuListFixedMobile2Data from '../../../components/Blocks/BlockMenuListFixedMobile2/BlockMenuListFixedMobile2Data';
import BlockMenuListEqualMobile2Data from '../../../components/Blocks/BlockMenuListEqualMobile2/BlockMenuListEqualMobile2Data';
import BlockMenuListEqualMax2Data from '../../../components/Blocks/BlockMenuListEqualMax2/BlockMenuListEqualMax2Data';
import BlockMenuListEqualMax3Data from '../../../components/Blocks/BlockMenuListEqualMax3/BlockMenuListEqualMax3Data';

interface Props {
  open: boolean
  handleClose: () => void
  handleSave: (blockData: BlockData) => void
}

const atomicBlockList = [
  BlockType.HEADER, BlockType.HEADER_WITH_LOGO, BlockType.HEADER_LOGO_MENU,
  BlockType.HEADER_FREE, BlockType.HEADER_WITH_LOGO_FREE, BlockType.HEADER_LOGO_MENU_FREE,
  BlockType.TITLE, BlockType.IMAGE, BlockType.TXT_BACKGROUND, BlockType.IMAGE_TEXT, BlockType.MENU_LIST_3, BlockType.MAP,
  BlockType.TEXT, BlockType.TEXT_LIST, BlockType.BUTTON,
  BlockType.HTML_SAFE, BlockType.HTML,
  BlockType.CARD_LEFT, BlockType.CARD_RIGHT,
  BlockType.CARD_LEFT_CENTERED,
  BlockType.CARD_RIGHT_CENTERED,
  BlockType.TITLE_TXT_BUTTON,
  BlockType.TXT_BACKGROUND_TALL, BlockType.TITLE_TXT_BUTTON_TALL,
  BlockType.BUTTON_LIST,
  BlockType.CAROUSEL, BlockType.CAROUSEL_TALL, BlockType.CAROUSEL_FIXED, BlockType.CAROUSEL_FIXED_TALL,
  BlockType.IMAGE_LIST,
  BlockType.TABLE,
  BlockType.TABLE_BOTTOM_BORDER,
  BlockType.TABLE_NO_BORDER,
  BlockType.CENTERED_IMAGE,
  BlockType.FULL_BLEED_IMAGE,
  BlockType.FULL_BLEED_CARD_LEFT_CENTERED, BlockType.FULL_BLEED_CARD_RIGHT_CENTERED,
  BlockType.LINED_TITLE,
  BlockType.I_FRAME_SAFE, BlockType.I_FRAME_SERVICES, BlockType.I_FRAME,
  BlockType.SNS,
  BlockType.ANIMATION_COMPONENT,
  BlockType.ANIMATION_WITH_DESCRIPTION_COMPONENT,
  BlockType.CONTACT,
  BlockType.VIDEO,
  BlockType.BLOCK_MENU_LIST_WITH_COLUMNS,
  BlockType.BLOCK_MENU_LIST_WITH_EQUAL_SPACE,
  BlockType.BLOCK_MENU_LIST_FIXED_MAX_2,
  BlockType.BLOCK_MENU_LIST_FIXED_MAX_3,
  BlockType.BLOCK_MENU_LIST_FIXED_MOBILE_2,
  BlockType.BLOCK_MENU_LIST_EQUAL_MOBILE_2,
  BlockType.BLOCK_MENU_LIST_EQUAL_MAX_2,
  BlockType.BLOCK_MENU_LIST_EQUAL_MAX_3,
  BlockType.FOOTER, BlockType.FOOTER_FREE,
];

const addNewAtomicBlock = (index: number) => {
  const { defaultImageUrl } = config;
  switch (index) {
    case BlockType.HEADER:
      return BlockData.make(BlockType.HEADER, BlockHeaderData.getDefault());
    case BlockType.HEADER_WITH_LOGO:
      return BlockData.make(BlockType.HEADER_WITH_LOGO, BlockHeaderWithLogoData.getDefault(false, defaultImageUrl));
    case BlockType.HEADER_LOGO_MENU:
      return BlockData.make(BlockType.HEADER_LOGO_MENU, BlockHeaderLogoMenuData.getDefault(false, defaultImageUrl));
    case BlockType.HEADER_FREE:
      return BlockData.make(BlockType.HEADER_FREE, BlockHeaderData.getDefault(true));
    case BlockType.HEADER_WITH_LOGO_FREE:
      return BlockData.make(BlockType.HEADER_WITH_LOGO_FREE, BlockHeaderWithLogoData.getDefault(true, defaultImageUrl));
    case BlockType.HEADER_LOGO_MENU_FREE:
      return BlockData.make(BlockType.HEADER_LOGO_MENU_FREE, BlockHeaderLogoMenuData.getDefault(true, defaultImageUrl));
    case BlockType.TITLE:
      return BlockData.make(BlockType.TITLE, BlockTitleData.getDefault());
    case BlockType.IMAGE:
      return BlockData.make(BlockType.IMAGE, BlockImageData.getDefault(defaultImageUrl));
    case BlockType.TXT_BACKGROUND:
      return BlockData.make(BlockType.TXT_BACKGROUND, BlockTextWithBackgroundData.getDefault(BlockHeight.NORMAL, defaultImageUrl));
    case BlockType.TXT_BACKGROUND_TALL:
      return BlockData.make(BlockType.TXT_BACKGROUND_TALL, BlockTextWithBackgroundData.getDefault(BlockHeight.TALL, defaultImageUrl));
    case BlockType.IMAGE_TEXT:
      return BlockData.make(BlockType.IMAGE_TEXT, BlockImageAndTextData.getDefault(defaultImageUrl));
    case BlockType.MENU_LIST_3:
      return BlockData.make(BlockType.MENU_LIST_3, BlockMenuListData.getDefault(undefined, defaultImageUrl));
    case BlockType.MAP:
      return BlockData.make(BlockType.MAP, BlockMapData.getDefault());
    case BlockType.TEXT:
      return BlockData.make(BlockType.TEXT, BlockTextData.getDefault());

    case BlockType.TEXT_LIST:
      return BlockData.make(BlockType.TEXT_LIST, BlockTextListData.getDefault());

    case BlockType.BUTTON:
      return BlockData.make(BlockType.BUTTON, BlockButtonData.getDefault());

    case BlockType.HTML:
      return BlockData.make(BlockType.HTML, BlockHtmlData.getDefault());

    case BlockType.CARD_LEFT:
      return BlockData.make(BlockType.CARD_LEFT, BlockCardData.getDefault(BlockCardVariant.Left, defaultImageUrl));

    case BlockType.CARD_RIGHT:
      return BlockData.make(BlockType.CARD_RIGHT, BlockCardData.getDefault(BlockCardVariant.Right, defaultImageUrl));

    case BlockType.CARD_LEFT_CENTERED:
      return BlockData.make(BlockType.CARD_LEFT_CENTERED, BlockCardCenteredData.getDefault(BlockCardCenteredVariant.Left, defaultImageUrl));

    case BlockType.CARD_RIGHT_CENTERED:
      return BlockData.make(BlockType.CARD_RIGHT_CENTERED, BlockCardCenteredData.getDefault(BlockCardCenteredVariant.Right, defaultImageUrl));

    case BlockType.TITLE_TXT_BUTTON:
      return BlockData.make(BlockType.TITLE_TXT_BUTTON, BlockTitleTextButtonData.getDefault(undefined, undefined, undefined, undefined, defaultImageUrl));

    case BlockType.TITLE_TXT_BUTTON_TALL:
      return BlockData.make(BlockType.TITLE_TXT_BUTTON_TALL, BlockTitleTextButtonData.getDefault(BlockHeight.TALL, BlockAlign.CENTER, undefined, undefined, defaultImageUrl));

    case BlockType.BUTTON_LIST:
      return BlockData.make(BlockType.BUTTON_LIST, BlockButtonListData.getDefault());

    case BlockType.CAROUSEL:
      return BlockData.make(BlockType.CAROUSEL, BlockCarouselData.getDefault(defaultImageUrl));

    case BlockType.CAROUSEL_TALL:
      return BlockData.make(BlockType.CAROUSEL_TALL, BlockCarouselData.getDefault(defaultImageUrl, BlockHeight.TALL));

    case BlockType.CAROUSEL_FIXED:
      return BlockData.make(BlockType.CAROUSEL_FIXED, BlockCarouselData.getDefault(defaultImageUrl, BlockHeight.NORMAL, false, 6, true));

    case BlockType.CAROUSEL_FIXED_TALL:
      return BlockData.make(BlockType.CAROUSEL_FIXED_TALL, BlockCarouselData.getDefault(defaultImageUrl, BlockHeight.TALL, false, 6, true));

    case BlockType.IMAGE_LIST:
      return BlockData.make(BlockType.IMAGE_LIST, BlockImageListData.getDefault(defaultImageUrl));

    case BlockType.TABLE:
      return BlockData.make(BlockType.TABLE, BlockTableData.getDefault());

    case BlockType.TABLE_BOTTOM_BORDER:
      return BlockData.make(BlockType.TABLE_BOTTOM_BORDER, BlockTableData.getDefault(BlockTableVariant.BorderBottom));

    case BlockType.TABLE_NO_BORDER:
      return BlockData.make(BlockType.TABLE_NO_BORDER, BlockTableData.getDefault(BlockTableVariant.NoBorder));

    case BlockType.CENTERED_IMAGE:
      return BlockData.make(BlockType.CENTERED_IMAGE, BlockCenteredImageData.getDefault(defaultImageUrl));

    case BlockType.FULL_BLEED_IMAGE:
      return BlockData.make(BlockType.FULL_BLEED_IMAGE, BlockFullBleedImageData.getDefault(defaultImageUrl));

    case BlockType.FULL_BLEED_CARD_LEFT_CENTERED:
      return BlockData.make(BlockType.FULL_BLEED_CARD_LEFT_CENTERED, BlockCardCenteredData.getDefault(BlockCardCenteredVariant.Left, defaultImageUrl, BlockJustify.START));

    case BlockType.FULL_BLEED_CARD_RIGHT_CENTERED:
      return BlockData.make(BlockType.FULL_BLEED_CARD_RIGHT_CENTERED, BlockCardCenteredData.getDefault(BlockCardCenteredVariant.Right, defaultImageUrl, BlockJustify.START));

    case BlockType.LINED_TITLE:
      return BlockData.make(BlockType.LINED_TITLE, BlockLinedTitleData.getDefault());

    case BlockType.I_FRAME:
      return BlockData.make(BlockType.I_FRAME, BlockiFrameData.getDefault());
    case BlockType.SNS:
      return BlockData.make(BlockType.SNS, BlockSNSData.getDefault(defaultImageUrl));
    case BlockType.ANIMATION_COMPONENT:
      return BlockData.make(BlockType.ANIMATION_COMPONENT, BlockAnimationBlockData.getDefault(defaultImageUrl));
    case BlockType.ANIMATION_WITH_DESCRIPTION_COMPONENT:
      return BlockData.make(BlockType.ANIMATION_WITH_DESCRIPTION_COMPONENT, BlockAnimationWithImageDescriptionData.getDefault(defaultImageUrl));
    case BlockType.CONTACT:
      return BlockData.make(BlockType.CONTACT, BlockContactData.getDefault(null));
    case BlockType.FOOTER:
      return BlockData.make(BlockType.FOOTER, BlockFooterData.getDefault(false, `Copyright ${new Date().getFullYear()}`));
    case BlockType.FOOTER_FREE:
      return BlockData.make(BlockType.FOOTER_FREE, BlockFooterData.getDefault(true, `Copyright ${new Date().getFullYear()}`));
    case BlockType.VIDEO:
      return BlockData.make(BlockType.VIDEO, BlockVideoData.getDefault());
    case BlockType.BLOCK_MENU_LIST_WITH_COLUMNS:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_WITH_COLUMNS, BlockMenuListWithColumnsData.getDefault(undefined, defaultImageUrl));
    case BlockType.BLOCK_MENU_LIST_WITH_EQUAL_SPACE:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_WITH_EQUAL_SPACE, BlockMenuListWithEqualSpaceData.getDefault(undefined, defaultImageUrl));

    case BlockType.HTML_SAFE:
      return BlockData.make(BlockType.HTML_SAFE, BlockHtmlSafeData.getDefault());

    case BlockType.I_FRAME_SAFE:
      return BlockData.make(BlockType.I_FRAME_SAFE, BlockiFrameSafeData.getDefault());

    case BlockType.I_FRAME_SERVICES:
      return BlockData.make(BlockType.I_FRAME_SERVICES, BlockiFrameSafeData.getDefault());

    case BlockType.BLOCK_MENU_LIST_FIXED_MAX_2:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_FIXED_MAX_2, BlockMenuListFixedMax2Data.getDefault(undefined, defaultImageUrl));
    case BlockType.BLOCK_MENU_LIST_FIXED_MAX_3:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_FIXED_MAX_3, BlockMenuListFixedMax3Data.getDefault(undefined, defaultImageUrl));
    case BlockType.BLOCK_MENU_LIST_FIXED_MOBILE_2:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_FIXED_MOBILE_2, BlockMenuListFixedMobile2Data.getDefault(undefined, defaultImageUrl));
    case BlockType.BLOCK_MENU_LIST_EQUAL_MOBILE_2:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_EQUAL_MOBILE_2, BlockMenuListEqualMobile2Data.getDefault(undefined, defaultImageUrl));
    case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_2:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_EQUAL_MAX_2, BlockMenuListEqualMax2Data.getDefault(undefined, defaultImageUrl));
    case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_3:
      return BlockData.make(BlockType.BLOCK_MENU_LIST_EQUAL_MAX_3, BlockMenuListEqualMax3Data.getDefault(undefined, defaultImageUrl));
    default:
      return null;
  }
};

const Index = (props: Props) => {
  const { open, handleClose, handleSave } = props;
  const [selectingAtomicBlock, setSelectingAtomicBlock] = useState<BlockType | null>(null);

  const handleSelected = () => {
    const blockData = addNewAtomicBlock(selectingAtomicBlock);
    handleSave(blockData);
  };

  return (
    <>
      <ModalComponent
        loading={false}
        errorMessage=""
        size="xl"
        title="ベースブロックの選択"
        confirmButtonText="選択する"
        onConfirm={handleSelected}
        show={open}
        closeModal={() => {
          handleClose();
        }}
        centered
        animation={false}
        scrollable
        contentClassName="fullViewportHeight"
      >
        <div className="tab modalTabs">
          <ul className="nav navTabs" role="tablist" style={{ overflow: 'auto' }}>
            <li><a className="active" href="#tabSection_1" data-bs-toggle="tab" role="tab">ベース</a></li>
          </ul>
          <div className="tab-content tabContent">
            <div id="tabSection_1" className="tab-pane tabPane active">
              <div className="block-list blockselect">
                {atomicBlockList.map((b) => (
                  <AtomicBlockItem
                    blockType={b}
                    key={b}
                    active={b === selectingAtomicBlock}
                    onMenuItemSelect={setSelectingAtomicBlock}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </ModalComponent>
    </>
  );
};

export default Index;
